var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { SiteHeaderLayout } from './site-header-layout';
import { useSiteHeader } from '../hooks/use-site-header';
import { SliceLayout } from './slice-layout';
import { get } from 'lodash';
import { ThemeModeProvider } from '../context/theme-mode-context';
import { useComponentProps } from '../context/component-props-context';
var cls = classNames('page-header');
export var PageHeaderDefaultProps = {
  aspectRatio: {
    base: 16 / 9,
    desktop: 21 / 9
  },
  showOverlayGradient: true,
  useBackgroundColor: false,
  showSlideControls: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  "])))
});
var BannerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    .shp--image-entity-background,\n    .shp--image-entity-background-slideshow {\n      overflow: visible;\n    }\n  "], ["\n    .shp--image-entity-background,\n    .shp--image-entity-background-slideshow {\n      overflow: visible;\n    }\n  "])))
});
var SiteHeaderStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    flex-grow: 1;\n    display: flex;\n    justify-self: stretch;\n    flex-direction: column;\n    justify-content: center;\n  "], ["\n    flex-grow: 1;\n    display: flex;\n    justify-self: stretch;\n    flex-direction: column;\n    justify-content: center;\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'PageHeader',
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  SiteHeader: styled(SiteHeaderLayout)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), SiteHeaderStyles),
  Banner: styled(SliceLayout)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), BannerStyles),
  Body: styled(SliceLayout)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles)
};
export var PageHeader = function (props) {
  var _a = useComponentProps(My.NAME, PageHeaderDefaultProps, props),
    className = _a.className,
    children = _a.children,
    aspectRatio = _a.aspectRatio,
    entity = _a.entity,
    showSlideControls = _a.showSlideControls,
    themeMode = _a.themeMode,
    fadeColor = _a.fadeColor,
    overlayColor = _a.overlayColor,
    useEntityColors = _a.useEntityColors,
    siteHeaderProps = __rest(_a, ["className", "children", "aspectRatio", "entity", "showSlideControls", "themeMode", "fadeColor", "overlayColor", "useEntityColors"]);
  var header = useSiteHeader();
  var variant = header.variant;
  // convert the Page into a slice to feed into SliceLayout
  var backgroundImages = entity.banners || entity.banner && [entity.banner] || [];
  var hasBackgroundImages = backgroundImages.length > 0;
  var hasMultipleBackgroundImages = backgroundImages.length > 1;
  var pageSlice = __assign(__assign({}, entity), {
    backgroundImages: backgroundImages
  });
  if (!hasBackgroundImages || props.useBackgroundColor) {
    pageSlice.backgroundColor = {
      value: props.backgroundColor || '#202124'
    };
  }
  // console.log("props theme mode", themeMode);
  // console.log("BANNER THEME MODE", get(entity, 'bannerThemeMode.slug'));
  // console.log("ENTITY THEME MODE", get(entity, 'themeMode'));
  var actualThemeMode = get(entity, 'bannerThemeMode.slug', get(entity, 'themeMode.slug', themeMode || (hasBackgroundImages ? 'dark' : 'auto')));
  var siteHeader = React.createElement(SiteHeaderLayout, __assign({}, siteHeaderProps));
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, variant !== 'overlay' && siteHeader, React.createElement(My.Banner, {
    useEntityColors: useEntityColors,
    overlayColor: overlayColor,
    showSlideControls: showSlideControls,
    fadeColor: fadeColor,
    boundary: 'none',
    // useAutoOverlay={hasMultipleBackgroundImages && variant === 'overlay'}
    entity: pageSlice,
    aspectRatio: aspectRatio
  }, variant === 'overlay' && siteHeader, React.createElement(ThemeModeProvider, {
    value: actualThemeMode
  }, children && React.createElement(My.Body, {
    entity: entity,
    boundary: "content"
  }, children))));
};
PageHeader.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;